/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Columnmenu_Showall2Inputs */

const en_columnmenu_showall2 = /** @type {(inputs: Columnmenu_Showall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show All`)
};

const de_columnmenu_showall2 = /** @type {(inputs: Columnmenu_Showall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle anzeigen`)
};

/**
* | output |
* | --- |
* | "Show All" |
*
* @param {Columnmenu_Showall2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const columnmenu_showall2 = /** @type {((inputs?: Columnmenu_Showall2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Columnmenu_Showall2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_columnmenu_showall2(inputs)
	return de_columnmenu_showall2(inputs)
});
export { columnmenu_showall2 as "columnMenu_showAll" }